<template>
  <footer class="navigation-footer">
    <p class="navigation-footer__copyright">{{ currentYear }} &copy; Ophelia Fournier-Laflamme</p>
  </footer>
</template>

<script>
export default {
  name: 'NavigationFooter',
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>
